import { colors } from '../constants/colors';

// Должен совпадать с LeadStatus.ManagerAssigned на бэке (Crm/Leads/Models/LeadStatus.cs).
export const LEAD_STATUS_MANAGER_ASSIGNED = 1;

/**
 * Фон строки в списке лидов — по тому, что с лидом нужно сделать.
 *
 * Розовый — ответственного нет, лид никто не принял (кнопка «Принять»).
 * Бежевый — принят, но менеджер ещё ничего не сделал: статус остался «Назначен
 * менеджер», сделки нет. Без цвета — лид в работе или закрыт.
 * undefined — правило ни при чём, дальше решает общая раскраска таблицы.
 */
const leadRowColor = (lead) => {
  if (!lead?.manager) return colors.rowRedBG;
  if (lead.status?.id === LEAD_STATUS_MANAGER_ASSIGNED && !lead.dealStatus) return colors.rowYellowBG;
  return undefined;
};

export default leadRowColor;
